import React, { useState } from "react";
import { Container, Row, Col, Form, Card, } from "react-bootstrap";
import { IoIosArrowForward } from "react-icons/io";
import { Link, useNavigate } from "react-router-dom";
import { addPlan } from "../../store/slices/plan";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";

export default function AddPlan() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [form, setForm] = useState({
    name: "",
    price: "",
    duration: "",
    durationType: "",
    contactViews: "",
    verifiedBadge: false,
    profileHighlight: false,
    description: "",
  });
  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);

  const handleChange = (name, value) => {
    const numericFields = ["price", "duration"];

    if (numericFields.includes(name)) {
      value = value.replace(/\D/g, "");
    }

    let error = "";

    if (name === "name") {
      if (!value.trim()) error = "Please enter plan name";
    } else if (name === "price") {
      if (!value) error = "Please enter price";
    } else if (name === "duration") {
      if (!value) error = "Please select duration";
    } else if (name === "contactViews") {
      if (value === "") error = "Please select contact views";
    }

    setForm((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: error }));
  };


  const validateForm = () => {
    let newErrors = {};

    if (!form.name) {
      newErrors.name = "Please select plan name";
    }

    if (!form.price) newErrors.price = "Please enter price";
    else if (!/^[0-9]+$/.test(form.price))
      newErrors.price = "Price must be numbers only";

    if (!form.duration) newErrors.duration = "Please select duration";


    if (form.contactViews === "") {
      newErrors.contactViews = "Please select contact views";
    }

    return newErrors;
  };
  const handleSubmit = (e) => {
    e.preventDefault();

    if (submitting) return;

    const validationErrors = validateForm();
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length > 0) return;

    setSubmitting(true);

    const payload = {
      name: form.name,

      price: Number(form.price),

      currency: "INR",

      duration: Number(form.duration),

      durationType: form.durationType,

      limits: {
        chats: -1,
        contactViews: Number(form.contactViews),
      },

      features: {
        verifiedBadge: form.verifiedBadge,
        profileHighlight: form.profileHighlight,
      },

      description: form.description,
    };

    dispatch(addPlan(payload))
      .unwrap()
      .then(() => {
        toast.success("Plan added successfully");
        navigate("/admin/plan");
      })
      .catch((err) => {
        toast.error(err?.message || "Add plan failed");
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  return (
    <>
      {/* Breadcrumb */}
      <div className="breadcrumb-bar mb-4">
        <div className="breadcrumb-left">
          <Link to="/admin/home" className="breadcrumb-link active">
            Home
          </Link>
          <span className="breadcrumb-separator">
            <IoIosArrowForward size={15} />
          </span>
          <Link to="/admin/plan" className="breadcrumb-link active">
            Plans
          </Link>
          <span className="breadcrumb-separator">
            <IoIosArrowForward size={15} />
          </span>
          <span className="breadcrumb-link inactive">Add Plan</span>
        </div>
      </div>

      <Container className="py-2">
        <Card className="p-4">
          <Form>
            <Row className="g-3 p-2">

              <Col md={3}>
                <Form.Label className="labelcolor">
                  Plan Name
                </Form.Label>

                <Form.Control
                  type="text"
                  placeholder="Enter Plan Name"

                  value={form.name}
                  maxLength={30}
                  onChange={(e) => handleChange("name", e.target.value)}
                />

                {errors.name && (
                  <small style={{ color: "red", fontSize: "13px" }}>
                    {errors.name}
                  </small>
                )}
              </Col>

              <Col md={3}>
                <Form.Label className="labelcolor">
                  Price (₹)
                </Form.Label>
                <Form.Control

                  value={form.price}
                  onChange={(e) => handleChange("price", e.target.value)}
                  placeholder="4999"
                  maxLength={5}
                />
                {errors.price && (
                  <small style={{ color: "red", fontSize: "13px" }}>
                    {errors.price}
                  </small>
                )}
              </Col>

              <Col md={3}>
                <Form.Label className="labelcolor">
                  Duration
                </Form.Label>
                <Form.Select
                  value={form.duration}
                  onChange={(e) => {
                    const value = e.target.value;

                    handleChange("duration", value);

                    handleChange(
                      "durationType",
                      value === "1" ? "years" : "months"
                    );
                  }}
                >
                  <option value="">Select Duration</option>
                  <option value="3">3 Months</option>
                  <option value="6">6 Months</option>
                  <option value="1">1 Year</option>
                  <option value="2">2 Years</option>
                </Form.Select>
                {errors.duration && (
                  <small style={{ color: "red", fontSize: "13px" }}>
                    {errors.duration}
                  </small>
                )}
              </Col>



              <Col md={3}>
                <Form.Label className="labelcolor">
                  Contact Views
                </Form.Label>
                <Form.Select
                  value={form.contactViews}
                  onChange={(e) => handleChange("contactViews", e.target.value)}
                >
                  <option value="">Select Contact Views</option>
                  <option value="-1">Unlimited</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="75">75</option>
                  <option value="100">100</option>
                  <option value="150">150</option>
                  <option value="200">200</option>
                </Form.Select>
                {errors.contactViews && (
                  <small style={{ color: "red", fontSize: "13px" }}>
                    {errors.contactViews}
                  </small>
                )}
              </Col>



              <Col md={3}>
                <Form.Label className="labelcolor">
                  Verified Badge
                </Form.Label>
                <div >
                  <input
                    type="checkbox"
                    checked={form.verifiedBadge === true}
                    onChange={(e) =>
                      handleChange("verifiedBadge", e.target.checked)
                    }

                    className="my-2"
                  />
                  <span style={{ fontSize: "14px", marginLeft: "4px" }}>
                    {form.verifiedBadge ? "Enabled" : "Disabled"}
                  </span>
                </div>
                {errors.verifiedBadge && (
                  <small style={{ color: "red", fontSize: "13px" }}>
                    {errors.verifiedBadge}
                  </small>
                )}
              </Col>
              <Col md={3}>
                <Form.Label>Profile Highlight</Form.Label>

                <div>
                  <input
                    type="checkbox"
                    checked={form.profileHighlight}
                    onChange={(e) => handleChange("profileHighlight", e.target.checked)}
                  />

                  <span style={{ marginLeft: 5 }}>
                    {form.profileHighlight ? "Enabled" : "Disabled"}
                  </span>
                </div>

              </Col>

              <Col md={12}>
                <Form.Label className="labelcolor">
                  Description
                </Form.Label>
                <Form.Control
                  as="textarea"
                  value={form.description}
                  onChange={(e) => handleChange("description", e.target.value)}
                  placeholder="Enter Description"
                />
              </Col>
            </Row>

            {/* Buttons */}
            <div className="d-flex justify-content-center gap-3 mt-4">
              <button
                type="button"
                className="cancel-btn"
                onClick={() => navigate("/admin/plan")}
              >
                Cancel
              </button>
              <button
                type="button"
                className="submit-btn"
                onClick={handleSubmit}
                disabled={submitting}
              >
                {submitting ? "Submitting..." : "Submit"}
              </button>
            </div>
          </Form>
        </Card>
      </Container>
    </>
  );
}
